import DescriptionSectionView from './DescriptionSectionView';

export default DescriptionSectionView;
